import { Loading } from '@softwareimaging/react';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Meta } from '../../lib/meta';
import { useAuthentication } from '../../services/authentication/AuthenticationProvider';

export const Redirect: FC = () => {
  const onRedirect = useAuthentication(state => state.onRedirect);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const path = await onRedirect();
      if (path && path !== '/auth/redirect' && path !== '/auth/signout' && path !== '/auth/signin') {
        navigate(path);
        return;
      }

      navigate('/');
    })();
  }, [navigate]);

  return (
    <>
      <Meta title="Redirecting" />
      <Loading className="h-screen" />
    </>
  );
};
